let token = null;

export default {
  setToken(t) {
    token = t;
  },
  getToken() {
    return token;
  },
  clear() {
    token = null;
  },
};
